import { type CachedHierarchyEntryResponseDto } from '@redteclab/api/clients/bully'

const getParent = (
  parents: CachedHierarchyEntryResponseDto[],
): CachedHierarchyEntryResponseDto[] => {
  const parent = parents.at(0)?.parent

  if (parent) {
    return getParent([parent, ...parents])
  }

  return parents
}

export const storyblokGetHierarchyCategoryList = (
  hierarchy: CachedHierarchyEntryResponseDto,
): CachedHierarchyEntryResponseDto[] => getParent([hierarchy])
